module.exports = __webpack_public_path__ + "static/media/NiaDayGuideHeader1.b6e231ea.png";